<template>
  <div class="time">
    <div class="time-top">
      <div class="time-top-title">
        <a class="o-color"
          >氧气：上限值：{{
            maintainData.oxygenUpper === "null"
              ? "--"
              : maintainData.oxygenUpper
          }}%&nbsp;下限值：{{
            maintainData.oxygenLower === "null"
              ? "--"
              : maintainData.oxygenLower
          }}%</a
        >
      </div>
      <div class="time-top-sign">
        <div class="sign-normal"></div>
        <div>正常</div>
        <div class="sign-abnormal"></div>
        <div>异常</div>
      </div>
    </div>
    <div class="time-center">
      <div class="loading-data" v-if="loading">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后···</div>
      </div>
      <div
        class="time-center-list-box"
        v-if="!loading && tableData.length > 0"
        v-for="(data, index) in tableData"
        :key="index"
        :class="{ 'time-center-list-box-active': data.exceptionFlag }"
        @click="toSensorHistory(data)"
      >
        <!-- <div class="diubao_show" v-if="data.packetLossFlag">丢包</div> -->
          <!-- 是否丢包  packetLossFlag -->
        <div class="box-num-box o-color" v-if="data.type === '01'">
          <div class="box-num">
            {{ data.oxygen }}
            <div>%</div>
          </div>
        </div>
        <div class="box-num-box c-color" v-if="data.type === '02'">
          <div class="box-num">
            {{ data.concentrationCo2 }}
            <div>PPM</div>
          </div>
        </div>
        <div class="box-num-box" v-if="data.type === '03'">
          <div class="box-num t-color" style="margin-right: 1vw">
            {{ data.temp }}
            <div>℃</div>
          </div>
          <div class="box-num h-color">
            {{ data.moisture }}
            <div>%</div>
          </div>
        </div>
        <div class="box-coordinates">
          X:{{ data.siteX }}&nbsp;Y:{{ data.siteY }}&nbsp;Z:{{ data.siteZ }}
        </div>
        <div class="box-date">{{ data.time }}</div>
        <div
          class="box-title"
          :class="{ 'box-title-active': data.exceptionFlag }"
        >
          <span>{{ data.stack }}</span>
          <!-- 烟叶代码（年份） -->
          <!-- <span>{{ data.materialName }}({{ data.year }})</span> -->
          <!-- 封垛时间 -->
          <!-- <span>{{ data.materialTime }}</span> -->
        </div>
      </div>
      <div class="none-data" v-if="!loading && tableData.length < 1">
        暂无数据
      </div>
    </div>
    <div class="page-wrapper" v-if="total > rows">
      <div class="page-wrapper-left">
        共{{ total }}条数据,共{{ Allpages }}页，每页显示{{ rows }}条，当前第{{
          page
        }}页
      </div>
      <div class="page-wrapper-right">
        <div class="page-btn" @click="firstPage">首页</div>
        <div class="page-btn" @click="previousPage">上一页</div>
        <div class="page-btn" @click="Tzpage">跳转至</div>
        <div class="page-btn"><input  v-model="page" /></div>
        <div class="page-btn" @click="nextPage">下一页</div>
        <div class="page-btn" @click="lastPage">尾页</div>
      </div>
    </div>
  </div>
</template>

<script>
import click from "../../../../tools/click";
import { searchMonitorData } from "../../../../api/maintain";
import { renderTime } from "../../../../tools/methods";
import localforage from 'localforage'
export default {
  name: "TimeOxygen",
  data: function () {
    return {
      loading: true,
      moduleType: "02",
      nodeType: "01",
      siteId: "",
      siteType: "",
      page: 1,
      rows: 12,
      total: "",
      // 总页数
      Allpages: 0,
      tableData: [],
      maintainData: {
        oxygenLower: "",
        oxygenUpper: "",
      },
      maintainStage: "",
      materialCode: "",
      materialName: "",
      sort: 0,
    };
  },
  created() {
    let _this = this
    localforage.getItem('page_rem_crib_timeOxygen').then(res => {
      if (res) {
        _this.page=res
        _this.handleSearch();
      }
    })
    this.handleSearch();  
  },
  mounted() {
    let that = this;
    click.$on(
      "click_first",
      function (siteId, siteType, maintainStage, materialCode, materialName) {
        that.siteId = siteId;
        that.siteType = siteType;
        that.page = 1;
        that.maintainStage = maintainStage;
        that.materialCode = materialCode;
        that.materialName = materialName;
        that.handleSearch();
      }
    );
    click.$on("click_sort", function (sort) {
      that.sort = sort;
      that.handleSearch();
    });
  },
  methods: {
    handleSearch: function () {
      let body = {
        moduleType: this.moduleType,
        noType: this.nodeType,
        page: this.page,
        rows: this.rows,
        siteId: this.siteId,
        siteType: this.siteType,
        maintainStage: this.maintainStage,
        materialCode: this.materialCode,
        materialName: this.materialName,
        sort: this.sort,
      };
      this.loading = true;
      searchMonitorData(body)
        .then((res) => {
          console.log(res);
          if (res.data.total) {
            this.maintainData.oxygenLower = res.data.rows[0].oxygenLower + "";
            this.maintainData.oxygenUpper = res.data.rows[0].oxygenUpper + "";
          }
          res.data.rows.map((item) => {
            item.sign = 0;
            item.time = renderTime(item.time);
            item.materialTime = renderTime(item.materialTime);
          });
          this.tableData = res.data.rows;
          this.total = res.data.total;
          this.loading = false;
          this.all = false;
          this.idList = [];
           // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toSensorHistory: function (data) {
       localforage.setItem('page_rem_crib_history', 1)
      console.log(data);
      this.$router.push({
        path: "/crib/timeMonitoring/sensorHistory",
        query: {
          nodeId: data.nodeId,
          type: data.type,
          index: "2",
          value: "1",
        },
      });
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
         localforage.setItem('page_rem_crib_timeOxygen', this.page)
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        localforage.setItem('page_rem_crib_timeOxygen', this.page)
        this.handleSearch();
      } else {
        localforage.setItem('page_rem_crib_timeOxygen', this.page)
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        localforage.setItem('page_rem_crib_timeOxygen', this.page)
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        localforage.setItem('page_rem_crib_timeOxygen', this.page)
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        localforage.setItem('page_rem_crib_timeOxygen', this.page)
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Time.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/crib/timeMonitoring/TimeOxygen.vue